import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { AIAssistantLoadingIndicator } from 'src/components/assistant/AssistantLoadingIndicator';

interface DesktopAppInterstitialProps {
  onDismiss: () => void;
}

export const DesktopAppInterstitial: React.FC<DesktopAppInterstitialProps> = ({
  onDismiss,
}) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white">
      <AIAssistantLoadingIndicator size={64} />

      <p className="text-2xl font-bold mb-12">
        {t(($) => $.desktop_app.interstitial.launching)}
      </p>

      <section className="text-center text-secondary">
        <p className="m-0 mb-2">
          {t(($) => $.desktop_app.interstitial.redirected)}
        </p>
        <p className="m-0">
          <Trans
            i18nKey="desktop_app.interstitial.open_in_browser"
            components={{
              Link: (
                <button
                  className="border-none bg-transparent p-0 m-0 hover:underline cursor-pointer"
                  onClick={onDismiss}
                  type="button"
                />
              ),
            }}
          />
        </p>
      </section>
    </div>
  );
};
